module.exports = __webpack_public_path__ + "img/roaming-ic.710b1e21.svg";